<app-ex-navbar></app-ex-navbar>
<router-outlet></router-outlet>
<app-ex-footer></app-ex-footer>
